import createRequestSlice, { requestInitialState } from 'redux/request/reducer';

export const PREFIX = 'families';

export const initialState = {
  ...requestInitialState,
  data: [],
};

const familiesSlice = createRequestSlice({
  name: PREFIX,
  initialState,
  reducers: {
    fetch(state, { payload }) {
      return {
        ...state,
        data: [...payload],
      };
    },
  },
});

export const actions = { ...familiesSlice.actions };
export const requests = { ...familiesSlice.requests };

export default familiesSlice.reducer;
